import { AgentNatureMandate, MandateService, OlkyPassProLinkType } from "@/features/company/types";
import { OlkyPassCustomerStatus } from "@/molecules/olkypass-customer-status/label";
import { StaticLinkNatureRelationEnum } from "@/utils/static-data/nature-relation";

export enum LinkStatusEnum {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  REJECTED = "REJECTED"
}

export enum DocumentConsentStatusType {
  TO_SIGN = "TO_SIGN",
  EXPIRED = "EXPIRED",
  SIGNED = "SIGNED"
}

// See src\domain\core\shared\dto\link-olkypass-pro.dto.ts
export type LinkSchemas = {
  // Link Olkypass Pro //
  uuid: string;
  type: OlkyPassProLinkType;
  invitationStatus: LinkStatusEnum | null;
  isAgentLe: boolean;
  isCommunicationContact: boolean;
  mandateServices: MandateService[];
  minimumOlkyPassLevel: number;

  agentCompanyName: string | null;
  agentNatureOther: string | null;
  agentUpgradeOlkypassAsk: string | null;

  beneficialOwnerPercentage: number | null;
  beneficialOwnerRelations: StaticLinkNatureRelationEnum[];
  beneficialOwnerNatureRelationOther: string | null;

  agentNature: {
    defaultName: AgentNatureMandate;
  } | null;
  realIdentity: {
    uuid: string;
    mail: string | null;
  };
  naturalPerson: {
    firstname: string;
    lastname: string;
    birthDate: string | null;
  };
  olkyPass: {
    uuid: string;
    level: number;
    levelUnderAudit: number;
    olkyPassCustomerStatus: OlkyPassCustomerStatus;
  };
  documentConsentStatus: DocumentConsentStatusType | null;
};
